import {  useState } from "react";

export default function CustomCursor({children}) {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [clicked, setClicked] = useState(false);


  return (
    // Sized so the video's 100% resolves against the stage rather than the stream's own pixel size.
    <div
        style={{ width: "100%", height: "100%" }}
        onMouseMove={(e) => {
            setPos({ x: e.clientX, y: e.clientY });
        }}
            onMouseDown={(e)=>{if (e.button !== 0) return; setClicked(true)}}
            onMouseUp={()=>setClicked(false)}
            onMouseLeave={()=>setClicked(false)}>
        <div
            
        style={{
            position: "fixed",
            left: pos.x,
            top: pos.y,
            width: 14,
            height: 14,
            borderRadius: "50%",
            background: "white",
            opacity: clicked ? 0.10 : 0,
            pointerEvents: "none",
            transform: `translate(-50%, -50%) scale(${clicked ? 1.35 : 1})`,
            transition: "opacity 120ms ease, transform 120ms ease",
            zIndex: 9999,
        }}
        />
    
        {children}
    </div>
  );
}
